module.exports = __webpack_public_path__ + "img/esteelauder_logo_header.69ce437b.png";